import React from "react";
import { Link } from "react-router-dom";
import "./CentersCard.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";

export default function CentersCard({ center, searchTerm }) {
  const HighlightText = ({ text }) => {
    if (!searchTerm || !text) {
      return text || "";
    }

    const textStr = String(text);

    // global and case insenstive = gi
    const regex = new RegExp(`(${searchTerm})`, "gi");
    return textStr?.split(regex).map((part, index) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <mark key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </mark>
      ) : (
        part
      )
    );
  };
  return (
    <Card style={{ width: "18rem" }}>
      {/* <Card.Img
        variant="top"
        src={center?.image}
        alt="Health center logo"
        className="center-image"
      /> */}
      <Card.Body>
        <Card.Title
          as={Link}
          to={`/healthcenters/${center?.id}`}
          style={{ fontSize: "20px", fontWeight: "600" }}
        >
          <HighlightText text={center?.name} />
        </Card.Title>
        {center.type && (
          <Card.Text>
            <b>Type: </b>
            <HighlightText text={center?.type} />
          </Card.Text>
        )}
        {/* <Card.Text>
          {center?.health_center_location_type_short_description}
        </Card.Text> */}
      </Card.Body>
      <ListGroup className="list-group-flush">
        <ListGroup.Item id="location">
          <strong>Address: </strong>
          <HighlightText text={center?.site_address} />
        </ListGroup.Item>
        <ListGroup.Item id="number">
          <strong>Phone Number: </strong>
          <HighlightText text={center?.phone_number} />
        </ListGroup.Item>
        <ListGroup.Item id="text">
          <strong>Center Type: </strong>
          <HighlightText text={center?.center_type} />
        </ListGroup.Item>
        <ListGroup.Item id="text">
          <strong>Location Type: </strong>
          <HighlightText text={center?.location_type} />
        </ListGroup.Item>
      </ListGroup>
      <Card.Body>
        <Card.Link
          target="_blank"
          rel="noreferrer"
          href={"https://" + center?.website_url}
        >
          Visit Website
        </Card.Link>
      </Card.Body>
    </Card>
  );
}
